import React, { useContext, useMemo } from 'react';
import { Flex } from '@mantine/core';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import {
	DATE_FORMATS,
	formatStringDateToUiWithFallback,
} from '@dealstack/shared/lib/format/dates/date.ts';
import { SecurityDetailsControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/useSecurityDetailsController';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { EditableInfoField } from '@dealstack/frontend/shared/components/EditableInfoField/EditableInfoField.tsx';

export const SecurityMoreDetailsTabPanel = () => {
	const tCapManage = useTranslationCapManage();

	const { getSecurityDetailsRequest } = useContext(SecurityDetailsControllerContext);
	const { persons } = useContext(CapManageControllerContext);

	const data = getSecurityDetailsRequest?.data;
	const formattedDateWithFallback = formatStringDateToUiWithFallback(
		data?.createdAt,
		DATE_FORMATS.CALENDAR_DATE,
		LONG_DASH
	);

	const issuerName = useMemo(
		() =>
			data?.issuerId && persons?.find((entity) => entity.id === data.issuerId)?.computedName,
		[persons, data]
	);

	return (
		<Flex p="1rem" gap="1.75rem" direction="column">
			<EditableInfoField
				label={tCapManage('securities.drawer.dateCreated.label')}
				data={formattedDateWithFallback}
			/>
			<EditableInfoField
				label={tCapManage('securities.drawer.createdBy.label')}
				data={issuerName ?? data?.issuerId}
			/>
			<EditableInfoField
				label={tCapManage('securities.drawer.dealstackId.label')}
				data={data?.id}
			/>
		</Flex>
	);
};
